import { Draft } from '@reduxjs/toolkit';

import { IProductData } from '../../index';

function changeStatusFailure(draft: Draft<IProductData>) {
  draft.changeStatus.config.isLoading = false;
}

export default changeStatusFailure;
